module.exports = __webpack_public_path__ + "img/06cggl.74e95ee9.svg";